import React from 'react';
import { cn } from '../../lib/cn';

export type PillTone = 'neutral' | 'success' | 'gold' | 'warning' | 'info' | 'ai';
export interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: PillTone;
  variant?: PillTone | 'default' | 'error';
  size?: 'sm' | 'md' | 'lg';
  dot?: boolean;
}

const pillTones: Record<PillTone, string> = {
  neutral: 'bg-[var(--cream-0)] text-[var(--ink-2)]',
  success: 'bg-[var(--success-tint)] text-[var(--success)]',
  gold: 'bg-[var(--gold-tint)] text-[#9A6B1E]',
  warning: 'bg-[var(--terracotta-tint)] text-[var(--terracotta)]',
  info: 'bg-[var(--info-tint)] text-[var(--info)]',
  ai: 'bg-[var(--ai-tint)] text-[var(--ai-3)]',
};

export function Pill({ children, className, dot, tone, variant, ...props }: PillProps) {
  const resolvedTone = tone ?? (variant === 'default' || variant === 'error' ? 'neutral' : variant) ?? 'neutral';
  return (
    <span {...props} className={cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-[var(--r-pill)] px-[11px] py-1 text-[11.5px] font-semibold tracking-[0.01em]', pillTones[resolvedTone], className)}>
      {dot ? <span className="h-1.5 w-1.5 rounded-full bg-current" /> : null}
      {children}
    </span>
  );
}

export const Badge = Pill;
